var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.1215 1.88892C13.193 1.88892 12.3417 2.17676 11.5914 2.74446C10.872 3.28872 10.1111 4.48601 10.1111 4.48601C10.1111 4.48601 9.35019 3.28872 8.63082 2.74446C7.88047 2.17676 7.02919 1.88892 6.10068 1.88892C3.50955 1.88892 1.55554 3.96228 1.55554 6.71177C1.55554 9.68217 3.99331 11.7145 7.68376 14.7911C8.31045 15.3136 9.0208 15.9058 9.75912 16.5374C9.85644 16.6208 9.98143 16.6667 10.1111 16.6667C10.2408 16.6667 10.3658 16.6208 10.4631 16.5375C11.2015 15.9057 11.9118 15.3135 12.5388 14.7908C16.2289 11.7145 18.6667 9.68217 18.6667 6.71177C18.6667 3.96228 16.7126 1.88892 14.1215 1.88892Z",
    fill: props.fill,
    stroke: props.fill,
    strokeWidth: 2
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFilled);
export default __webpack_public_path__ + "static/media/heart_filled.ed9f117b62fa68096ed3404e34a1c0e2.svg";
export { ForwardRef as ReactComponent };